import React from 'react';
import { Grid, Row } from 'react-flexbox-grid';
import { Parallax } from 'react-scroll-parallax';
import base from '../../base.styl';
import styles from './ImageCallout.styl';

const ImageCallout = props => {
  let width = window.innerWidth

  let disableParallax = false//(width >= 769) ? false : true

  return (
    <div className={styles.calloutContainer}>
      <Parallax offsetYMax={5} offsetYMin={-10} tag="callout" disabled={disableParallax}>
        <Row className={styles.block}>
          <div className={styles.imageWrapper}>
            <div
              className={styles.image}
              style={{
                backgroundImage:
                  'url(https://s3-us-west-2.amazonaws.com/ifaw-congress/african-elephant-2.jpg)'
              }}
            />
          </div>
          <div className={styles.textBlock}>
            <h1 className={styles.title}>take action</h1>
            <p>
              Contacting your legislators in Congress is just one of the many
              ways you can support the ESA and the wildlife species it protects.
              Here are some other ways to get involved:
            </p>
            <ol>
              <li>
                Spread awareness to your friends by posting on your social media
                channels using <a href="https://twitter.com/search?q=%23oneactforall&src=typd" className={styles.link} target="_blank" rel="noopener noreferrer">#oneactforall</a>
              </li>
              <li>Submit an op-ed to your local paper.</li>
              <li>
                <a
                  href="https://www.fws.gov/endangered/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  Educate
                </a>{' '}
                yourself about this landmark environmental law and all of the
                species it protects.
              </li>
              <li>
                Find out about ESA-listed species in your area and spread the
                word about them. What your community can do to help them
                recover? You can use this{' '}
                <a
                  href="https://www.fws.gov/endangered/map/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                interactive map
                </a>{' '}
                on the U.S. Fish and Wildlife Service’s website to get started.
              </li>
            </ol>
          </div>
        </Row>
      </Parallax>
    </div>
  );
};

export default ImageCallout;



// WEBPACK FOOTER //
// ./src/components/static/ImageCallout.js